import script from "./NewsPageRubricsEditPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageRubricsEditPopup.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageRubricsEditPopup.vue?vue&type=style&index=0&id=6f5f97dd&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f5f97dd"]])

export default __exports__